import reduce from 'lodash/reduce'

export function forEachPromise(arr, handler) {
  return reduce(
    arr,
    (current, item, index) => current.then(() => handler(item, index)),
    Promise.resolve(),
  )
}
